export default "__VITE_PUBLIC_ASSET__636d7d6f__"